import React from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { dbg } from "../../utils/general.utils"

/**
 * @typedef {import("prop-types").InferProps<typeof propTypes>} PropTypes
 * @param {Omit<import("react-router-dom").LinkProps, keyof PropTypes | "to"> & PropTypes} props
 * @returns
 */
const IndividualReportLink = ({ state, ...props }) => {
  dbg(() => {
    console.assert(!isNaN(state?.teamMemberId), "teamMemberId is NaN")
  })

  return <Link to="/reporte-individual" state={state} {...props} />
}

const propTypes = {
  state: PropTypes.shape({
    teamMemberId: PropTypes.number,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    period: PropTypes.string,
    taskId: PropTypes.number,
  }),
}

IndividualReportLink.propTypes = propTypes

export default IndividualReportLink
